/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCursorDefault = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M19.329 9.455 5.487 4.285a.55.55 0 0 0-.711.706l5.185 13.9a.552.552 0 0 0 1.041-.028l1.483-4.834 5.025 4.917a.55.55 0 0 0 .777 0l1.295-1.299a.553.553 0 0 0 0-.778l-5.009-4.895 4.756-1.475a.55.55 0 0 0 .37-.522.55.55 0 0 0-.37-.522" /></svg>;
export default SvgCursorDefault;